module.exports = __webpack_public_path__ + "static/media/zip-download.65c26c40.png";